import { createPaths } from "@routes/utils";

import type { IExtractRouteParamMap } from "@routes";

const baseRoute = `/report-management/purchase-report`;

export const purchaseReportRoutesObj = {
  list: baseRoute,
  // TODO: ADD VIEW INVOICE AND DEBT PAYMENT PAGES LATER
} as const;

export type IPurchaseReportRouteParams = IExtractRouteParamMap<
  typeof purchaseReportRoutesObj
>;

export const purchaseReportPath = createPaths<
  typeof purchaseReportRoutesObj,
  IPurchaseReportRouteParams
>(purchaseReportRoutesObj);
